import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandSecondary, hotPink, titles } from '../../../styles/colors';
import { BreakPoints, CssSelectors, cardStyle } from '../../../styles/styles';

/** Moved not necessarily desirable code */
export const styleSheet = StyleSheet.create({
	container: {
		...cardStyle,
		overflow: 'visible',
		boxSizing: 'border-box',
		display: 'inline-flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		position: 'relative',
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
		':last-child': {
			marginRight: 0,
		},
		marginRight: 20,
		width: '32%',
		[BreakPoints.forMaxWidth(1150)]: {
			width: '31%',
		},
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 2,
	},
	nameContainer: {
		borderTopLeftRadius: 9,
		borderTopRightRadius: 9,
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		gap: 8,
		alignItems: 'center',
		fontSize: 16,
		overflow: 'hidden',
		paddingTop: 30,
		textOverflow: 'ellipsis',
		width: '100%',
		...CssSelectors.allChildren(
			{
				maxWidth: '100%',
			},
			'div'
		),
	},
	newItem: {
		color: hotPink,
	},
	sharedByFooter: {
		color: THEME.colors.text.light,
		fontSize: '11px',
		fontStyle: 'italic',
		textAlign: 'center',
		padding: '8px 15px 0px 15px',
		marginTop: 8,
	},
	popoverContainer: {
		marginRight: 25,
	},
	textContainer: {
		minHeight: 64,
		flex: 1,
		marginBottom: 15,
	},
});
